import type {SafeHTMLString} from '@github-ui/safe-html'
import {VerifiedHTMLText} from '@github-ui/safe-html/VerifiedHTML'
import {Banner, Button} from '@primer/react'

import {LABELS} from './constants/labels'
import styles from './UserRestrictedView.module.css'

type UserRestrictedViewProps = {
  reasonHTML?: SafeHTMLString | null
  issuesUrl?: string
}

export const UserRestrictedView = ({reasonHTML, issuesUrl}: UserRestrictedViewProps) => {
  return (
    <div className={styles.userRestrictedContainer}>
      {reasonHTML && (
        <Banner aria-label="Warning" variant="warning" hideTitle title="Action restricted">
          <Banner.Description>
            <VerifiedHTMLText html={reasonHTML} />
          </Banner.Description>
        </Banner>
      )}
      {issuesUrl && (
        <Button as="a" href={issuesUrl} className={styles.backToAllIssuesButton}>
          {LABELS.backToAllIssues}
        </Button>
      )}
    </div>
  )
}

try{ UserRestrictedView.displayName ||= 'UserRestrictedView' } catch {}